import { ENV_VARS } from 'ENV_CONFIG';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import {
  getDomainAddress,
  isAddressInJohnLewisDomain,
  isReferrerToTheAppointments,
  isReferrerToTheHomePage,
  redirectedFromLoginPage,
} from '~/utils';
import { NextButton } from './NextButton';
import { PreviousButton } from './PreviousButton';
import styles from './ScreenNav.scss';

export class ScreenNav extends PureComponent {
  domainName = getDomainAddress(ENV_VARS.REACT_APP_STAGE);

  onNextClick = (event) => {
    // TODO change onNextClick to work with promise
    const { onNextClick } = this.props;

    event.preventDefault();
    onNextClick();
  };

  onPreviousClick = (event) => {
    const { history, prevPath, externalPrevPath, onPrevClick } = this.props;

    event.preventDefault();
    if (prevPath) {
      history.pushWithToken(prevPath);
    } else if (onPrevClick) {
      onPrevClick();
    } else if (externalPrevPath) {
      if (
        isAddressInJohnLewisDomain(document.referrer, this.domainName) &&
        !redirectedFromLoginPage(this.domainName) &&
        !isReferrerToTheHomePage(document.referrer) &&
        !isReferrerToTheAppointments(document.referrer)
      ) {
        window.location.replace(encodeURI(document.referrer));
      } else {
        window.location.replace(encodeURI(`${window.location.origin}${externalPrevPath}`));
      }
    } else {
      history.goBack();
    }
  };

  render() {
    const { prevButtonText, nextButtonText, submit, hideNextButton, children, formId } = this.props;

    let nextButton;
    if (hideNextButton) {
      nextButton = null;
    } else if (submit) {
      nextButton = <NextButton type="submit" text={nextButtonText} form={formId} />;
    } else {
      nextButton = <NextButton text={nextButtonText} onClick={this.onNextClick} />;
    }

    const extraClass = hideNextButton ? styles.ScreenNav_singleBtn : '';

    return (
      <div className={`${styles.ScreenNav} ${extraClass}`} data-testid="ScreenNav">
        <PreviousButton text={prevButtonText} onClick={this.onPreviousClick} />
        {nextButton}
        {children}
      </div>
    );
  }
}

export const WithRouterScreenNav = withRouter(ScreenNav);

ScreenNav.propTypes = {
  history: PropTypes.shape({}).isRequired,
  onNextClick: PropTypes.func,
  prevButtonText: PropTypes.string,
  nextButtonText: PropTypes.string,
  prevPath: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  externalPrevPath: PropTypes.string,
  onPrevClick: PropTypes.func,
  submit: PropTypes.bool,
  hideNextButton: PropTypes.bool,
  children: PropTypes.node,
};

ScreenNav.defaultProps = {
  prevButtonText: 'Go back',
  nextButtonText: 'Next',
  onNextClick: null,
  prevPath: null,
  externalPrevPath: null,
  onPrevClick: null,
  submit: false,
  hideNextButton: false,
  children: null,
};
